import React, { useMemo } from 'react';
import GenericModal from '@ui-components/Modal/GenericModal';
import { GenericTable } from '@ui-components/Table/GenericTable';
import { clusterIAMPermissionsColumns, ClusterIAMResponse } from './ClusterIAMPermissionsData';

interface ClusterIAMPermissionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  iamData: ClusterIAMResponse | null;
  loading: boolean;
  error: string | null;
}

const ClusterIAMPermissionsModal: React.FC<ClusterIAMPermissionsModalProps> = ({ 
  isOpen, 
  onClose, 
  iamData,
  loading,
  error
}) => {
  const columns = useMemo(() => {
    if (!iamData || !iamData.reflector1 || !iamData.reflector2) {
      return [];
    }
    return clusterIAMPermissionsColumns(iamData.reflector1.name, iamData.reflector2.name);
  }, [iamData]);

  return (
    <GenericModal
      isOpen={isOpen}
      onClose={onClose}
      title={<span className="text-xl font-bold">IAM Permissions</span>}
      size="lg"
      maxHeight="95vh"
      overflowY="auto"
      hideScrollbar={true}
    >
      <div className="mb-2 text-sm text-semantic-text-secondary">
        Showing IAM permissions for the cluster reflectors. Different permissions may indicate configuration issues.
      </div>
      {loading ? (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-4 border-gray-300 border-t-blue-500" />
        </div>
      ) : error ? (
        <div className="text-red-500 text-center py-4">{error}</div>
      ) : iamData && iamData.permissions ? (
        <GenericTable
          key={`iam-table-${iamData.reflector1.name}-${iamData.reflector2.name}`}
          columns={columns}
          data={iamData.permissions}
          tableClassName="bg-white"
          initialRowsPerPage={10}
          rowsPerPageOptions={[5, 10, 15]}
          width="100%"
          overflow="visible"
        />
      ) : (
        <div className="text-center py-8 text-semantic-text-secondary">
          No IAM permissions data available
        </div>
      )}
    </GenericModal>
  );
};

export default ClusterIAMPermissionsModal;
